/**
 * Dominio funcional de un nodo o sensor.
 * El manual de marca asigna un color a cada uno y esa semántica se mantiene
 * en dashboard, notificaciones e iconografía.
 */

export const DOMINIOS = ['seguridad', 'activos', 'servicios'] as const;
export type DominioValor = (typeof DOMINIOS)[number] | 'sin_categoria';

const ETIQUETA: Readonly<Record<DominioValor, string>> = {
  seguridad: 'Seguridad',
  activos: 'Activos',
  servicios: 'Servicios',
  sin_categoria: 'Sin categoría',
};

const TOKEN: Readonly<Record<DominioValor, string>> = {
  seguridad: '--domain-seguridad',
  activos: '--domain-activos',
  servicios: '--domain-servicios',
  sin_categoria: '--text-3',
};

export class Dominio {
  private constructor(readonly valor: DominioValor) {}

  static from(raw: string | null | undefined): Dominio {
    const limpio = (raw ?? '').trim().toLowerCase().replace(/[\s-]/g, '_');
    const valor = (DOMINIOS as readonly string[]).includes(limpio)
      ? (limpio as DominioValor)
      : 'sin_categoria';
    return new Dominio(valor);
  }

  static todos(): Dominio[] {
    return [...DOMINIOS, 'sin_categoria' as const].map((v) => new Dominio(v));
  }

  get etiqueta(): string {
    return ETIQUETA[this.valor];
  }

  get color(): string {
    return `var(${TOKEN[this.valor]})`;
  }

  get estaCategorizado(): boolean {
    return this.valor !== 'sin_categoria';
  }

  toString(): string {
    return this.valor;
  }
}
